import { useQuery } from 'react-query';
import CardRelatorio from './CardRelatorio';
import Valor from './Valor';
import axios from 'axios';
import Skeleton from '../../components/layout/Skeleton';
import { dateWithoutTimezone } from '../../lib/util';
import { translateFilter } from './util';

type Props = {
  periodo: [string, string, string];
  canal_id: number[];
};

const CardRelatorioTotalClientesAtendidos = ({ periodo, canal_id }: Props) => {
  const q = useQuery(
    ['totalClientesAtendidos', periodo, canal_id],
    async () => {
      const qs = new URLSearchParams();
      qs.append('facts', 'qtd_clientes');
      qs.append('filter', translateFilter({ periodo, canal_id }));

      const res = await axios.get(
        '/api/relatorios/chat_mensagem?' + qs.toString(),
      );
      return res.data.result[0].qtd_clientes ?? 0;
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio
      titulo="Clientes Atendidos"
      mostrarVisualizador={true}
      filtroVisualizador={{ periodo, canal_id }}
      dimensoesVisualizador={['nome']}
      hrefVisualizador="/api/relatorios/chat_mensagem"
      info="Quantidade de clientes únicos atendidos no período."
      csv
    >
      {q.isFetching ? <Skeleton format="box" /> : <Valor valor={q.data} />}
    </CardRelatorio>
  );
};

export default CardRelatorioTotalClientesAtendidos;
